import React from "react";
import Routes from "./Routes/index";
import UserWayWidget from './UserWayWidget';
//import Custom Style scss
import "./assets/scss/themes.scss";
function App() {
  return (
    <React.Fragment>
      <UserWayWidget />
      <Routes />
    </React.Fragment>
  );
}

export default App;
